import { render, staticRenderFns } from "./group-manage-one.vue?vue&type=template&id=3e31660c"
import script from "./group-manage-one.vue?vue&type=script&lang=js"
export * from "./group-manage-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports